import Vue from 'vue';
import array from 'lodash/array';
import OutsourcersFilter from '../readeableids/outsourcersfilter';

export default Vue.component('piececollectionresourcestock', {
    components:{
        'outsourcersfilter': OutsourcersFilter
    },
    template:`
    <fragment>
        <tbody>
            <tr @click="expanded = !expanded">
                <td class="text-center">
                    <i v-bind:class="['fa', expanded? 'fa-angle-down' : 'fa-angle-right', 'font-w600']"></i>
                </td>
                <td></td>
                <td>{{resource.code}}</td>
                <td>{{resource.name}}</td>
                <td>{{fractionsList.join(', ')}}</td>
                <td v-if="permissions.canEdit">
                    <outsourcersfilter v-model="resource.outsourcer.id" prefix="SP" v-bind:isFormField="false"
                        :text.sync="resource.outsourcer.code" :description.sync="resource.outsourcer.name" :readonly="disabledInputs" />
                </td>
                <td v-if="!permissions.canEdit">
                    <span>{{resource.outsourcer.name}}</span>
                </td>
                <td v-if="permissions.canEdit">
                    <button class="btn btn-sm btn-default" type="button" v-on:click="editCollectionResource(resource, $event)">
                        <i class="si si-pencil"></i>
                    </button>
                </td>
            </tr>
        </tbody>
        <tbody v-show="expanded">
            <tr v-for="fraction in resource.fractions">
                <td></td>
                <td class="text-center">
                    <div :id="'img-' + resource.code" style="display: none;">
                        <img :src='resourceImage' width='150'/>
                    </div>
                    <i v-if="resourceImage" class="si si-camera js-popover" data-html="true" :data-tooltip-element="'#img-' + resource.code"></i>
                </td>
                <td colspan="2"></td>
                <td>{{fraction.code}} {{fraction.subFraction}}</td>
                <td colspan="2"></td>
            </tr>
        </tbody>
    </fragment>    
    `,
    data: function(){
        return {
            expanded: false,
            disabledInputs: this.readonly
        }
    },
    props:{
        resource: Object,
        resourceImage: String,
        readonly: { type: Boolean, default: true },
        permissions: Object
    },
    computed: {
        fractionsList(){
            return array.uniq(this.resource.fractions.map(x => x.code));
        }
    },
    methods:{
        editCollectionResource(resource, event){
            event.stopPropagation();
            this.disabledInputs = !this.disabledInputs;
        }
    }
});